import { css, type Theme } from "@emotion/react";

export const blockQuote = (theme: Theme) =>
  css({
    marginLeft: "0.75rem",
    marginBottom: "1rem",
    paddingLeft: "0.75rem",
    borderLeft: `1px solid ${theme.separator.base}`,
  });
